import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { CrmPush } from 'crono-fe-common/types/crmPush';

export default function useGetActiveCrmPushes() {
  const queryClient = useQueryClient();

  const getActiveCrmPushes = () => {
    const request: Request = {
      url: `${ENDPOINTS.crmPush.active}`,
      config: {
        method: 'get',
      },
    };
    return client(request);
  };

  return useMutation<Response<CrmPush[]>, CronoError>(getActiveCrmPushes, {
    meta: { silentError: true },
    onSuccess: (data) => {
      if (data?.data?.data && Array.isArray(data.data.data)) {
        const pushes = data.data.data;
        const hasProspectPushes = pushes.some(
          (push) => push.tableType === 'Prospect',
        );
        const hasOpportunityPushes = pushes.some(
          (push) => push.tableType === 'Opportunity',
        );
        const hasAccountPushes = pushes.some(
          (push) => push.tableType === 'Account',
        );

        if (hasProspectPushes) {
          queryClient.invalidateQueries([ENDPOINTS.prospect.search.main]);
        }
        if (hasOpportunityPushes) {
          queryClient.invalidateQueries([ENDPOINTS.opportunity.search.main]);
        }
        if (hasAccountPushes) {
          queryClient.invalidateQueries([ENDPOINTS.account.search.main]);
        }
      }
    },
  });
}
